export const environment = {
  production: false,
  developer: 'Haulmatic',
  version: 2.2,
  haulmatic: {
    baseUrl: 'https://staging.app.haulmatic.com',
    apiGateway: 'https://staging.api.haulmatic.com'
  },
  google: {
    apiKey: 'AIzaSyBhHe3jP_tu9VkVCGZxVAVZW6bfWzcCiUY',
    // Front-end Maps key (same as index.html's Maps JS script); used for Static Maps images.
    mapsApiKey: 'AIzaSyD52yeMSeolrzqRaIWzpx0NVhYWJ4UDjIQ',
  },
  firebaseConfig: {
    apiKey: 'AIzaSyBnm74ZBrJ1v5PLwbPjLu9cW2yJaCzbGIw',
    authDomain: 'hmt-messaging-qa.firebaseapp.com',
    databaseURL: 'https://hmt-messaging-qa.firebaseio.com',
    projectId: 'hmt-messaging-qa',
    storageBucket: 'hmt-messaging-qa.appspot.com',
    messagingSenderId: '54583386837',
    appId: '1:54583386837:web:d70990a04464a26216b85c',
    measurementId: 'G-8WN375Z0C1'
  },
  useV2Layout: false, // Set to false for v1
  enableBookingEngine: false,
};
